import { useSyncExternalStore } from "react";

/** Modèle d'IA choisi sur ce poste (registres E26, E27) : « rapide », le modèle Generex de l'iPad, ou « avance »,
 *  plus riche et plus lent. Envoyé au serveur avec chaque requête (en-tête X-Generex-IA), qui le demande au serveur
 *  GPU. */
export type IaModel = "rapide" | "avance";

const KEY = "generex:ia";
const listeners = new Set<() => void>();
let current: IaModel = initial();

function initial(): IaModel {
  try {
    return localStorage.getItem(KEY) === "avance" ? "avance" : "rapide";
  } catch {
    return "rapide";
  }
}

export const iaModel = (): IaModel => current;

export function setIaModel(value: IaModel): void {
  if (value === current) return;
  current = value;
  try {
    localStorage.setItem(KEY, value);
  } catch {
    /* stockage indisponible : le choix vaut jusqu'au rechargement */
  }
  for (const listener of listeners) listener();
}

export function useIaModel(): IaModel {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => current,
  );
}

/** En-tête du modèle choisi, joint à toutes les requêtes de l'API. */
export const iaHeaders = (): Record<string, string> => ({ "X-Generex-IA": current });
